export class MinipaydTask {
  constructor ({ baseUrl = "http://localhost:5000", ...options } = {}) {
    this.baseUrl = baseUrl
    this.options = options
    this.runningTaskId = null
  }

  // Helper to build URLs safely
  buildUrl (path) {
    return new URL(path, this.baseUrl).toString()
  }

  // Helper to sleep
  sleep (ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

  // Helper to fetch JSON with error handling (always POST)
  async fetchJson (url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: body != null ? JSON.stringify(body) : undefined
    })
    if (!res.ok) {
      const text = await res.text().catch(() => '')
      throw new Error(`HTTP ${res.status} ${res.statusText}: ${text}`)
    }
    // Some endpoints might return empty body; try to parse JSON safely
    const ct = res.headers.get('content-type') || ''
    if (!ct.includes('application/json')) return null
    return res.json()
  }

  async exec (action, data) {
    if (this.runningTaskId) {
      throw new Error("Task already running")
    }

    const startUrl = this.buildUrl(action)
    const startResult = await this.fetchJson(startUrl, data)
    this.runningTaskId = startResult?.id ?? null
    if (!this.runningTaskId) {
      throw new Error('Failed to start task: missing id in response')
    }

    while (true) {
      const statusUrl = this.buildUrl(`task/${startResult.id}`)
      const paymentStatus = await this.fetchJson(statusUrl)
      // keep compatibility with previous axios.data usage
      const status = paymentStatus?.status
      this.terminalMessage = paymentStatus?.message
      if (["starting", "in_progress"].includes(status)) {
        await this.sleep(100)
      } else {
        break
      }
    }

    const finalStatusUrl = this.buildUrl(`task/${startResult.id}`)
    const finalStatus = await this.fetchJson(finalStatusUrl)
    this.runningTaskId = null
    return finalStatus
  }

  async abort () {
    if (this.runningTaskId) {
      try {
        const abortUrl = this.buildUrl(`payment/${this.runningTaskId}/abort`)
        await this.fetchJson(abortUrl)
      } catch (error) {
        // eslint-disable-next-line
        console.error(error)
      } finally {
        this.runningTaskId = null
      }
    }
  }
}
